import React, { useState, useEffect } from 'react';
import { fetchCropStatistics, getCropTypeInfo } from '../utils/croplandCrosAPI';

const CropStatistics = () => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [year, setYear] = useState(2022);

  useEffect(() => {
    const loadStatistics = async () => {
      try {
        setLoading(true);
        const data = await fetchCropStatistics(year);
        
        if (data.success === false) {
          // If API call failed, use the simulated stats
          setStatistics(data.simulatedStats);
        } else {
          // Process real API data
          setStatistics(data);
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Error loading crop statistics:', err);
        setError('Failed to load crop statistics. Please try again later.');
        setLoading(false);
      }
    };

    loadStatistics();
  }, [year]);

  const handleYearChange = (e) => {
    setYear(parseInt(e.target.value, 10));
  };

  if (loading) {
    return (
      <div className="crop-statistics loading">
        <h3>Crop Statistics</h3>
        <p>Loading statistics...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="crop-statistics error">
        <h3>Crop Statistics</h3>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  return (
    <div className="crop-statistics">
      <div className="statistics-header">
        <h3>DMV Region Crop Statistics</h3>
        <select value={year} onChange={handleYearChange}>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2019">2019</option>
        </select>
      </div>

      <div className="statistics-content">
        <table className="statistics-table">
          <thead>
            <tr>
              <th>Crop</th>
              <th>Acres</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            {statistics && Object.entries(statistics).map(([crop, data]) => {
              const cropInfo = getCropTypeInfo(crop);
              return (
                <tr key={crop}>
                  <td>
                    <span 
                      className="color-indicator" 
                      style={{ backgroundColor: cropInfo?.color || '#808080' }}
                    ></span>
                    {crop}
                  </td>
                  <td>{data.acres?.toLocaleString() || 'N/A'}</td>
                  <td>{data.percentage ? `${data.percentage}%` : 'N/A'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="statistics-footer">
        <p className="data-source">
          Source: USDA CroplandCROS {year} Data
        </p>
      </div>
    </div>
  );
};

export default CropStatistics; 